import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReportRelocationListItem = ResultOf<
  typeof reportRelocationListQuery
>["reportRelocations"][number];

export const reportRelocationListQuery = graphql(`
  query ReportRelocationList(
    $rangeStartDate: String!
    $rangeEndDate: String!
    $supplierId: ID
  ) {
    reportRelocations(
      supplier_id: $supplierId
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      relocation_reference
      status
      created_at
      supplier_name
      vehicle_name
      vehicle_type
      vehicle_transmission
      departure_office_name
      region
      delivery_office_name
      available_from_date
      available_to_date
      latest_departure_date
      remaining
      successful_bookings
      failed_bookings
      total
      currency
      hire_unit_type
      hire_unit_rate
      extra_hire_unit_rate
      hire_units_allowed
      extra_hire_units_allowed
      distance_allowed
      fuel_description
      ferry_description
    }
  }
`);
